<template lang="pug">
    div
        Modal(
            v-model="isModalShow"
            width="800"
        )
            div(slot="header")
                span {{ title }}
                span.extra(v-if="$can('write', permissionKey,managePageName)&& managePageName")
                    template(v-if="resourceData")
                        a(@click="goToManage") {{ $t('global.manage') }}
                    //- template(v-else)
                        span {{ $t('global.manage') }}
            template(v-if="resourceData")
                Row(v-for="field in renderFields" :key="field.key")
                    Col(span="6") {{ field.title }}
                    Col(span="18") 
                        template(v-if="!field.render")
                            span {{ resourceData[field.key] }}
                        template(v-else)
                            Render(:render="field.render" :renderData="resourceData")
            template(v-else)
                span  {{ $t('main.selectNotFoundText') }}
            div(slot="footer")
                Button(type="primary" @click="isModalShow = false") {{ $t('global.close') }}
        a(@click="getResource" v-if="!icon") {{ title }}
        Tooltip(:content="`Check ${title} information`" v-else)
            Button(@click="getResource" :icon="icon" v-if="!buttonText")
            Button(@click="getResource" v-else) {{buttonText}}


</template>
<script>
import { _getResource } from "@/api/rest/index.js";
import { _dateFormat } from "@/libs/dateformat.js";
import Render from "@/components/render.js";

export default {
    name: "getResourceBtn",
    props: [
        "title",
        "endPoint",
        "docId",
        "keyField",
        "managePageName",
        "renderFields",
        "groupName",
        "permissionKey",
        "buttonText",
        "icon"
    ],
    components: { Render },
    watch: {},
    created() {},
    beforeDestroy() {},
    data() {
        return {
            isModalShow: false,
            resourceData: []
        };
    },
    methods: {
        getResource() {
            _getResource(this.endPoint, this.docId, this.groupName)
                .then(result => {
                    this.resourceData = result.data.data;
                    this.isModalShow = true;
                })
                .catch(err => {
                    console.log(err);
                });
        },
        goToManage() {
            let query = { groupName: this.resourceData.groupName };
            query[this.keyField] = this.resourceData[this.keyField];
            this.$router.push({
                name: this.managePageName,
                query
            });
        }
    },
    mounted() {},
    computed: {}
};
</script>
<style scoped lang="less">
.extra {
    position: absolute;
    right: 50px;
    top: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/getResourceBtn.vue